import { runInnerFunction } from "../compatManager";
import { getLawyerFirstName, getLawyerLastName, getLawyerNode } from "../livedataFuncs";

export function formatAMPM(date) { // date obj, move this to library
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

export function formatAMPMString(timeOfCreate) { // string obj => 13:45
    let timeOfCreateArr = timeOfCreate.split(":");
    let hour = parseInt(timeOfCreateArr[0]);
    var ampm = hour >= 12 ? 'pm' : 'am';
    if (hour !== 12)
        hour = hour % 12;
    return hour + ':' + timeOfCreateArr[1] + ' ' + ampm;
}

export function LocalYearMonthDayHourMinuteString() {
    let currDate = new Date();

    let LocalMonth = (currDate.getMonth()) + 1;
    let LocalDay = currDate.getDate();
    let LocalYear = currDate.getFullYear();
    let LocalHour = currDate.getHours();

    let LocalHourString = LocalHour.toString();
    if (LocalHour < 10) {
        LocalHourString = '0' + LocalHour;
    }
    let LocalMinute = currDate.getUTCMinutes();
    let LocalMinuteString = LocalMinute.toString();
    if (LocalMinute < 10) {
        LocalMinuteString = '0' + LocalMinute;
    }

    let UTCDate = LocalMonth + "/" + LocalDay + "/" + LocalYear + " " + LocalHourString + ":" + LocalMinuteString;
    return UTCDate;
}

export function YearMonthDayHourMinuteString() {
    let currDate = new Date();

    let UTCMonth = (currDate.getUTCMonth()) + 1;
    let UTCDay = currDate.getUTCDate();
    let UTCYear = currDate.getUTCFullYear();
    let UTCHour = currDate.getUTCHours();

    let UTCHourString = UTCHour.toString();
    if (UTCHour < 10) {
        UTCHourString = '0' + UTCHour;
    }
    let UTCMinute = currDate.getUTCMinutes();
    let UTCMinuteString = UTCMinute.toString();
    if (UTCMinute < 10) {
        UTCMinuteString = '0' + UTCMinute;
    }

    let UTCDate = UTCMonth + "/" + UTCDay + "/" + UTCYear + " " + UTCHourString + ":" + UTCMinuteString;
    return UTCDate;
}

export function replyToNoteFunc(props, index) {
    let noteTextarea = (document.getElementsByName('replybox-' + index)[0] as HTMLInputElement).value;
    let lawyerNode = getLawyerNode(props);
    let lawyerFirstName = getLawyerFirstName(lawyerNode);
    let lawyerLastName = getLawyerLastName(lawyerNode);
    let utcDate = LocalYearMonthDayHourMinuteString();
    let arrayContent = [noteTextarea, index, lawyerFirstName, lawyerLastName, utcDate];
    runInnerFunction('createXMLElementAddToLiveDataRootNoteReply', arrayContent);
}

export function lawyerInitialsFuncs(lawyerFirstName, lawyerLastName) {
    let lawyerInitials = "";
    if (lawyerFirstName) {
        lawyerInitials += lawyerFirstName.substring(0, 1);
    }
    if (lawyerLastName) {
        lawyerInitials += lawyerLastName.substring(0, 1);
    }
    return lawyerInitials;
}

export function createDateToAMPMTime(nodeObj) {
    let timeOfCreate = "";
    let createDateArr = [];
    if (nodeObj?.getAttribute('CreateDate')) {
        createDateArr = (nodeObj.getAttribute('CreateDate')).split(" ");
    }
    else {
        createDateArr = nodeObj.CreateDate.split(" ");
    }
    timeOfCreate = createDateArr[1];
    timeOfCreate = formatAMPMString(timeOfCreate);
    return timeOfCreate;
}

export function createDateToAMPMTimeNew(date: string) {
    let timeOfCreate = "";
    let createDateArr = date.split(" ");
    timeOfCreate = createDateArr[1];
    timeOfCreate = formatAMPMString(timeOfCreate);
    return timeOfCreate;
}

export function createDateDayMonthYear(nodeObj: string) {
    let dayMonthYear = "";
    let createDateArr = nodeObj.split(" ");
    dayMonthYear = createDateArr[0];
    return dayMonthYear;
}

export function deleteNote(index: number) {
    runInnerFunction('deleteReactStickyNote', index);
}

export function deleteNoteReply(index: number, replyIndex: number) {
    runInnerFunction('reactRemoveNoteReply', [index, replyIndex]);
}

export function userInitials(name: string) {
    let userInitials = "";
    let nameArr = name.split(" ");
    nameArr.length === 2 ? userInitials = nameArr[0][0].toLocaleUpperCase() + nameArr[1][0].toLocaleUpperCase()
        : userInitials = nameArr[0][0].toLocaleUpperCase()
    return userInitials;
}